<template>
    <button :disabled="disabled || loading" :type="type"
            class="inline-flex items-center px-4 py-2 border border-transparent rounded-md font-bold text-xs uppercase tracking-widest focus:outline-none transition ease-in-out duration-150 justify-center"
            :class="[{ 'opacity-50 cursor-not-allowed' : disabled,
                'cursor-wait' : loading,
            }, buttonType]"
    >
        <slot></slot>
        <font-awesome-icon
            :icon="['far', 'spinner']"
            class="fa-spin text-xl ml-2"
            v-if="loading"
        />
    </button>
</template>

<script>

    export default {
        props: {
            type: {
                type: String,
                default: 'submit',
            },
            disabled: {
                type: Boolean,
                default: false
            },
            secondary: {
                type: Boolean,
                default: false,
            },
            danger: {
                type: Boolean,
                default: false,
            },
            text: {
                type: Boolean,
                default: false,
            },
            loading: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            buttonType()     {
                if (this.secondary) {
                    return 'secondary';
                }
                if (this.danger) {
                    return 'danger';
                }
                if (this.text) {
                    return 'text';
                }
                return 'primary';
            },
        }
    }
</script>

<style lang="scss" scoped>
button:not(.text) {
    @apply text-white;
}

.primary {
    @apply bg-orange-400;
    &:hover {
        @apply bg-orange-500;
    }
    &:active {
        @apply bg-orange-600;
    }
    &:focus {
        @apply bg-orange-600 ring-2 ring-orange-500 ring-offset-2;
    }
}

.secondary {
    @apply bg-blue-400;
    &:hover {
        @apply bg-blue-500;
    }
    &:active {
        @apply bg-blue-600;
    }
    &:focus {
        @apply bg-blue-600 ring-2 ring-blue-500 ring-offset-2;
    }
}

.danger {
    @apply bg-red-600;
    &:hover {
        @apply bg-red-500;
    }
    &:active {
        @apply bg-red-600;
    }
    &:focus {
        @apply bg-red-600 ring-2 ring-red-500 ring-offset-2;
    }
}

.text {
    @apply text-sm leading-5 text-gray-700;
    &:hover {
        @apply bg-gray-100 text-gray-900;
    }
    &:focus {
        @apply bg-gray-100 text-gray-900 outline-none;
    }
}
</style>